import Swiper from 'swiper';
import { refs, domReady, booleanDataset } from '../modules/utils.js';
import { test as testMedia } from '../modules/match-media.js';

class ProductsSlider extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#slider();
    this.#listeners();
  }

  #listeners() {
    this.refs.next?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slideNext();
      }
    });

    this.refs.prev?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slidePrev();
      }
    });
  }

  #slider() {
    if (!this.refs.slider) return;
    const slidesCount = this.refs.slides?.length ?? 0;
    let hideNav = false;
    let initSlider = true;
    let slidesPerView = 4;
    let centeredSlides = false;

    if (testMedia('small')) {
      hideNav = true;
      slidesPerView = 1.3;
      centeredSlides = true;
    }
    else {
      if (slidesCount < 5) {
        initSlider = false;
        hideNav = true;
      }
    }

    if (initSlider) {
      this.slider = new Swiper(
        this.refs.slider,
        {
          slidesPerView,
          spaceBetween: 0,
          loop: false,
          centeredSlides
        }
      );

      this.slider.on('slideChange', () => {
        this.dataset.index = this.slider.realIndex;
      });
    }

    if (hideNav) {
      booleanDataset(this.refs.navWrapper, 'hidden', true);
    }
  }
}

customElements.define('products-slider', ProductsSlider);
